import React, { ReactElement } from "react";
import { EventSummaryProps } from "./EventModel";
import { formatDateTime } from "../utils/apiUtils";
import eventLogo from "../images/MIXOPIA_EVENT_BG_001.png";

const EventDetails = (
  props: React.PropsWithChildren<EventSummaryProps>
): ReactElement => (
  <div className="my-4">
    <div className="d-flex">
      <div className="me-4">
        <img src={eventLogo} height="72px" alt="mixopia event"/>
      </div>
      <div className="flex-fill">
        <h4>
          {props.event.name}
        </h4>
         <div className="body-copy-2">
          <div>{props.event.host.displayName}</div>
          <div>{formatDateTime(props.event.startTime)}</div>
          <div>{props.event.location}</div>
        </div>
      </div>
        {props.children && (
          <div>{props.children}</div>
        )}  
    </div>
  </div>
);

export default EventDetails;
